import script from "./AddCandidateToJobManual.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCandidateToJobManual.vue?vue&type=script&setup=true&lang=js"

import "./AddCandidateToJobManual.vue?vue&type=style&index=0&id=5c136fc2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/employer/employer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c136fc2"]])

export default __exports__